export default __webpack_public_path__ + "static/media/BCA26.34b71877.jpg";